// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_12PFSrYDrInik5VxZw4Sfa"};